<template>
  <section>
    <div class="popups">
      <b-sidebar
        v-model="showFilters"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
      >
        <template>
          <div class="container sidebar-header">
            <b-row>
              <div class="col">
                <b-button
                  variant="primary"
                  @click="
                    applyFilters();
                    loadItems();
                    showFilters = false;
                  "
                  >Apply</b-button
                >
              </div>

              <div class="col-auto text-right">
                <b-button
                  type="reset"
                  variant="outline-danger"
                  @click="resetFormFilters()"
                >
                  Reset
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="ml-1"
                  @click="
                    showFilters = false;
                    formFilters = { ...itemsFilters };
                  "
                >
                  Cancel
                </b-button>
              </div>
            </b-row>
          </div>

          <div class="px-3 py-2">
            <b-form-group label="Brand:">
              <b-v-select
                v-model="formFilters.brandId"
                :searchable="true"
                :options="brandsFilter"
              />
            </b-form-group>
            <b-form-group label="Name:">
              <b-form-input v-model="formFilters.name" />
            </b-form-group>
            <b-form-group label="Warehouse:">
              <b-v-select
                v-model="formFilters.warehouseId"
                :searchable="true"
                :options="warehousesFilter"
              />
            </b-form-group>
            <b-form-group label="External ID:">
              <b-form-input v-model="formFilters.externalId" />
            </b-form-group>
          </div>
        </template>
      </b-sidebar>
    </div>
    <div class="header">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <h1 class="header-title">
              Configure Fulfillment Boxes
            </h1>
          </div>
          <div class="col-auto">
            <router-link
              :to="{ name: 'BrandFulfillmentBoxes.Create' }"
              class="btn btn-success mr-2"
            >
              <i class="mr-2 fa fa-plus" />
              Add New
            </router-link>
            <b-button variant="primary" @click="showFilters = !showFilters">
              <i class="fa fa-filter mr-2"></i>
              Filters
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <TableListing
      class="mb-0"
      :loading-page="loadingItems"
      :failed-loading="failedLoadItems"
      head-variant="dark"
      :items.sync="items"
      :fields.sync="fields"
      :pagination.sync="pagination"
      :options.sync="tableOptions"
      v-on:pagination-changed="loadItems"
    >
      <template v-slot:cell(brandId)="data">
        <span
          v-if="myBrands && myBrands.find(a => a.id == data.item.brandId)"
          >{{ myBrands.find(a => a.id == data.item.brandId).name }}</span
        >
        <span v-else>-</span>
      </template>
      <template v-slot:cell(warehouseId)="data">
        <span
          v-if="myWarehouses && myWarehouses.find(a => a.id == data.item.warehouseId)"
          >{{ myWarehouses.find(a => a.id == data.item.warehouseId).name }}</span
        >
        <span v-else>-</span>
      </template>
      <template v-slot:cell(dimensions)="data">
        {{ data.item.length }}" x {{ data.item.width }}" x {{ data.item.height }}"
      </template>
      <template v-slot:cell(volume)="data">
        <span v-if="data.item.minVolume && data.item.maxVolume">
          {{ data.item.minVolume }} - {{ data.item.maxVolume }} in³
        </span>
        <span v-else-if="data.item.minVolume">
          Min: {{ data.item.minVolume }} in³
        </span>
        <span v-else-if="data.item.maxVolume">
          Max: {{ data.item.maxVolume }} in³
        </span>
        <span v-else>-</span>
      </template>
      <template v-slot:cell(createDateTimeUtc)="data">
        <span
          v-if="
            data.item.createDateTimeUtc &&
              !data.item.createDateTimeUtc.endsWith('Z')
          "
          >{{
            (data.item.createDateTimeUtc + 'Z') | moment('MMM Do YY, h:mm a')
          }}</span
        >
        <span v-else-if="data.item.createDateTimeUtc">{{
          data.item.createDateTimeUtc | moment('MMM Do YY, h:mm a')
        }}</span>
      </template>
      <template v-slot:cell(id)="data">
        <button
          type="button"
          class="btn btn-info ml-1"
          @click="EditItem(data.item)"
        >
          Edit
        </button>
        <b-button
          variant="danger"
          class="ml-1"
          v-b-tooltip.hover
          title="Delete"
          @click="DeleteItem(data.item.id)"
        >
          <i class="fa fa-trash"></i>
        </b-button>
      </template>
    </TableListing>
  </section>
</template>

<script>
import TableListing from '@/views/components/TableListing.vue';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  name: 'BrandFulfillmentBoxes.Index',
  mixins: [crudMixinGen('brandFulfillmentBoxes'), myCommonDataMixin],
  components: {
    TableListing
  },

  data: () => ({
    fields: [
      { key: 'brandId', label: 'Brand', sortable: false },
      { key: 'name', label: 'Name', sortable: false },
      { key: 'dimensions', label: 'Dimensions (L×W×H)', sortable: false },
      { key: 'weight', label: 'Weight (lbs)', sortable: false },
      { key: 'volume', label: 'Volume Range', sortable: false },
      { key: 'warehouseId', label: 'Warehouse', sortable: false },
      { key: 'externalId', label: 'External ID', sortable: false },
      { key: 'createDateTimeUtc', label: 'Created', sortable: false },
      { key: 'id', label: 'Action', sortable: false }
    ]
  }),
  mounted() {
    this.loadItems();
  },

  methods: {
    EditItem(item) {
      this.$router.push({
        name: 'BrandFulfillmentBoxes.Edit',
        params: { id: item.id }
      });
    }
  }
};
</script>